import {
  type BusinessDataType,
  DefaultBusinessRoleIdV2,
  type BusinessDataV2Type,
  type BusinessUserV2Client,
  type SingleUserProfileType,
} from '@am3nd-org/pointcraft-types';

export function mapBusinessData(business: BusinessDataV2Type): BusinessDataType {
  return {
    id: business.id,
    ...(business.accountNumber ? { accountNumber: business.accountNumber } : {}),
    name: business.name,
    isSuperAdmin: business.isSuperAdmin,
    address: business.businessInfo.address,
    features: business.configurations.features,
    permissions: business.configurations.permissions,
    email: business.businessInfo.email,
    phone: business.businessInfo.phone,
    website: business.businessInfo.website,
    logoUrl: business.businessInfo.logoUrl,
    offlineModeEnabled: business.configurations.offlineModeEnabled,
    // V4 business data intentionally has no legacy business-location list.
    // Manager resolves payment locations through its dedicated devices API.
    locations: [],
    financialDefaults: business.financialDefaults,
    productDefaults: { tags: [] },
    configurations: business.configurations,
    access_v2: business.access_v2,
    system_pin: business.system_pin,
  };
}

export function mapBusinessUser(
  user: BusinessUserV2Client,
  business: BusinessDataV2Type
): SingleUserProfileType {
  const role = business.access_v2.roleDefinitions.find((candidate) => candidate.id === user.roleId);

  return {
    name: user.profile.name,
    userId: user.id,
    email: user.profile.email,
    ...(user.profile.address ? { address: user.profile.address } : {}),
    ...(user.profile.phone ? { phone: user.profile.phone } : {}),
    isActive: user.isActive,
    isSuperAdmin: business.isSuperAdmin,
    isDefault: user.isDefault,
    features: business.configurations.features,
    permissions: business.configurations.permissions,
    configurations: {
      virtualKeyboard: false,
      notificationPreferences: user.notificationPreferences,
      ...(user.notificationPreferenceView
        ? { notificationPreferenceView: user.notificationPreferenceView }
        : {}),
    },
    role: role?.name ?? user.roleId,
    roleId: user.roleId,
    isStoreAdmin: user.roleId === DefaultBusinessRoleIdV2.OWNER,
  };
}
